<template>

    <slot name="toggler" :toggle="toggle">
        <button @click="isOpen = true;">{{ buttonText }}</button>
    </slot>


    <div v-if="isOpen" class="modal fixed z-10 inset-0 overflow-y-auto">
        <div class="modal__bg flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="modal__bg-inner fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true">

                <div class="modal__content max-h-80vh overflow-y-auto inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 p-1">

                    <div class="modal__header p-3 flex justify-between">
                        <slot name="header" :toggle="toggle">
                            <h4 class="text-white text-sm font-bold uppercase mb-3">{{ title }}</h4>
                            <button type="button" class="close" @click.prevent="isOpen = false">
                                <span>×</span>
                            </button>
                        </slot>
                    </div>

                    <div class="modal-body py-5 px-3">

                        <slot></slot>

                    </div>
                    <div class="modal-footer">

                        <slot name="footer" :toggle="toggle"></slot>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title', 'buttonText'],
    data() {
        return {
            isOpen: false,
        }
    },
    methods: {
        toggle(state = null) {
            if(state === null) {
                this.isOpen = !this.isOpen;
                return;
            }
            this.isOpen = state;
        }
    }
}
</script>
